import { CommitFn } from "../../../../../rest/Commit";
import { FlagActions } from "../../../../flux/Flag/FlagActions";
import { ErrorActions } from "../../../../flux/Error/ErrorActions";
import { ListActions } from "../../../../flux/Grid/ListActions";
import { EntityType, DivisionDraft } from "../../../../../models";
import { Polyglot } from "../../../../../polyglot";
import { appNavigator } from "../../../../routes";
import { Command1 } from "../../../../../Command";

export class UpsertDivisionCommand
{
    private inProgressActions = new FlagActions();
    private listActions = new ListActions();
    private errorActions = new ErrorActions();
    
    constructor(
        private polyglot: Polyglot,
        private commit: CommitFn,
        private changeCurrentDivisionCommand: Command1<number>, private getCurrentDivisionId: () => number,
        private listDispatchToken: string, private inProgressDispatchToken: string, private errorDispatchToken)
    {
    }

    execute = (entityDraft: DivisionDraft) => {
        if(!entityDraft)
            throw new Error('Program error. draft has to have value');

        const { Name, ParentId } = entityDraft;
        const setError = (msg: string) => this.errorActions.setError(new Error(msg), this.errorDispatchToken);
        if(typeof ParentId !== 'number') {
            setError(this.polyglot.t('division.validation_err.parent_not_set'));
            return;
        }
        if(typeof Name !== 'string' || Name.trim() === '') {
            setError(this.polyglot.t('division.validation_err.empty_name'));
            return;
        }

        const entityType = EntityType.Division;
        this.inProgressActions.set(this.inProgressDispatchToken);
        this.commit({ type: entityType, entity: entityDraft })
            .then(res => {
                if(res.Success) return res[EntityType[entityType]];
                throw new Error(res.ErrorMessage);
            })
            .then(entity => {
                this.listActions.upsertItems([entity], entityType);
                this.changeCurrentDivisionCommand.execute(this.getCurrentDivisionId());
                appNavigator.goToDivisionTab();
            })
            .catch(err => this.errorActions.setError(err, this.errorDispatchToken ))
            .then(() => this.inProgressActions.reset(this.inProgressDispatchToken)); // finaly
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Division/commands/UpsertDivisionCommand.ts